/**
 * Ocean carrier SCAC → display name, extracted from the cubes-catalog HTML.
 * Used by RateCard Edit Select and resolveCarrier fuzzy matching.
 */
export const CARRIERS_BY_CODE: Record<string, string> = {
  "11DX": "CNC (Cheng Lie Navigation)",
  "11PG": "Dongjin Shipping",
  "11QU": "Heung-A Shipping",
  "11WJ": "Jin Jiang Shipping (SHJJ)",
  "12AT": "Interasia Lines",
  "12GE": "Hai Hua Shipping (HASCO)",
  "12IH": "Sinotrans Container Lines",
  "12PD": "SITC Container Lines",
  "15AC": "Pan Continental Shipping",
  "32GG": "Taicang Container Lines",
  "32GH": "Nirint Shipping",
  "43LW": "Shandong Marine Corporation",
  ACLU: "Atlantic Container Line (ACL)",
  ADMU: "Admiral Container Lines",
  AEXU: "Africa Express Line",
  AJIQ: "WeFreight",
  AKKU: "Akkon Lines",
  ALKU: "Altun Logistics",
  ALLF: "Allalouf Shipping Line",
  ALRB: "AC Container Line",
  AMIG: "AMASS",
  ANNU: "Australia National Line (ANL)",
  ANRM: "Alianca",
  APLU: "American President Lines (APL)",
  ARKU: "Arkas",
  ASLU: "Asyad Line",
  AWOT: "Awot Global Logistics",
  BANQ: "Blue Anchor America Line",
  BAXU: "Sunmarine Shipping Services",
  BELC: "Bee Logistics",
  BLJU: "Avana Logistek",
  BLZU: "BLPL Singapore",
  BMSU: "BMC Line Shipping",
  BOPT: "PSA BDP",
  BOXU: "Boxline",
  BURU: "BAL Container Line",
  BWLE: "Blue World Line",
  BWLU: "Blue Water Lines (BWL)",
  CAKU: "Camellia Line",
  CELU: "Consort Express Lines",
  CEVA: "CEVA Logistics",
  CHKM: "Charter Link Logistics",
  CHVW: "Swire Shipping",
  CIAU: "Geodis Ocean",
  CKLU: "CK Line",
  CLYM: "Cleve & Zonen",
  CMCU: "Crowley Maritime",
  CMDU: "CMA CGM",
  COSU: "COSCO",
  CPNU: "Cargo-Partner",
  CQSQ: "Cosco Specialized",
  CRAU: "Cosiarma S.p.A.",
  CSYU: "Cordelia Container Shipping Line",
  CULU: "China United Lines (CULines)",
  CXLR: "Chenxin Shipping",
  DAYU: "Deutsche Afrika-Linien (DAL)",
  DHC2: "DHL Global Forwarding",
  DLTU: "Dalreftrans",
  DMAL: "Danmar Lines",
  DMCC: "Feeder Logistics",
  DMCQ: "Damco",
  DOLQ: "Dole Ocean Cargo Express",
  DSVF: "DSV Ocean Transport",
  DTRA: "Dachser",
  DWCH: "De Well Group",
  ECLU: "Ellerman City Liners",
  ECNU: "Econship",
  ECUW: "ECUW",
  EGLV: "Evergreen",
  EIMU: "Eimskip",
  EMKU: "Emkay Lines",
  ESCU: "Expressway Container Line",
  ESLU: "Ethiopian Shipping Line",
  ESPU: "Emirates Shipping Line",
  ESZO: "Euroconsol",
  EUCU: "Eucon",
  EUKO: "Eukor",
  EXPO: "EIO",
  FESO: "FESCO",
  FFLU: "Fairfreight Lines",
  FFPV: "FPS Famous Pacific Shipping B.V.",
  FOLK: "Folk Maritime",
  GETU: "Tarros",
  GFSH: "Global Freight Services",
  GRIU: "Grimaldi Deep Sea S.P.A.",
  GRMU: "Goodrich Maritime",
  GSLI: "GS Lines",
  GSLU: "Gold Star Line",
  GSSW: "G2 Ocean",
  HDMU: "Hyundai Merchant Marine (HMM)",
  HDUJ: "Hede Shipping",
  HEIC: "Hankyu Hanshin Express",
  HGLU: "Hillebrand Gori",
  HIFI: "Hellmann Worldwide Logistics",
  HIKU: "Hikaru Shipping Line",
  HLCU: "Hapag-Lloyd",
  HUAU: "Hoegh Autoliners",
  HYSL: "Hecny Shipping",
  ICCU: "PT. Indo Container Lines (ICON)",
  IILU: "Independent Container Line (ICL)",
  INOX: "INOX Shipping Line",
  JASO: "JAS Worldwide (Ocean)",
  KANW: "Kanway Line",
  KHNN: "Kuehne + Nagel (KN)",
  KKCL: "Kambara Kisen",
  KKLU: "Kawasaki Kisen Kaisha (K Line)",
  KLNL: "KLN Logistics Group Limited",
  KMTU: "Korea Marine Transport (KMTC)",
  KWEO: "Kintetsu World Express",
  LEHO: "Leschaco",
  LLNK: "Lotus Link",
  LMCU: "Ignazio Messina",
  LNLU: "Laurel Navigation",
  LQDC: "Lucky Logistics",
  MAEI: "Maersk Line Limited (MLL)",
  MAEU: "Maersk",
  MATS: "Matson Navigation Company (MATS)",
  MBFU: "Carpenters Shipping",
  MCSM: "Maritime Carrier Shipping (MACS)",
  MDLN: "M-Line",
  MEXU: "Mariana Express Lines (MELL)",
  MFTU: "Maritime Marfret",
  MGSU: "Marguisa Shipping Lines",
  MKLU: "Medkon Lines",
  MLCW: "Crane Worldwide Logistics",
  MOLU: "Mitsui O.S.K. Lines (MOL)",
  MRTU: "Meratus Line",
  MSCU: "Mediterranean Shipping Company (MSC)",
  MTTX: "MTT Shipping",
  MXCU: "Maxicon Container Line (MCL)",
  NCLI: "NVO Consolidation Lines",
  NEDF: "Nippon Express",
  NGPL: "New Guinea Pacific Line",
  NIDU: "Nile Dutch Africa Line",
  NOKU: "Nauka Lines",
  NSAU: "Bahri",
  NSCL: "North Sea Container Line (NCL)",
  NSHA: "National Shipping of America",
  NSQP: "Nissin Corporation",
  NSRU: "Namsung Shipping",
  NSTR: "NewStar",
  NYKS: "Nippon Yusen Kaisha (NYK Line)",
  OCSL: "Oceanic Star Line",
  ONEY: "Ocean Network Express (ONE)",
  OOLU: "Orient Overseas Container Line (OOCL)",
  OSLL: "Ocean Silk Line",
  OSTI: "Orient Star",
  OYLT: "Odyssey Logistics & Technology",
  PCIU: "Pacific International Lines (PIL)",
  PCSL: "Dong Young Shipping",
  PDLU: "Neptune Pacific Direct Line (NPDL)",
  PKEU: "LX Pantos",
  PLLU: "Polynesia Line",
  POBU: "Pan Ocean",
  PSEA: "Pacific Star Express (China)",
  PSHI: "Pasha Hawaii",
  PSL1: "PSL Navegacao",
  PYMN: "Pyramid Lines Singapore",
  QLVA: "Quanterm Logistics",
  QNLU: "Milaha - Qatar Navigation Q.P.S.C.",
  REGU: "Regional Container Lines (RCL)",
  ROMO: "Romocean",
  SCIU: "Shipping Corporation of India (SCI)",
  SDRA: "Sidra Line",
  SEHP: "Sea Legend Shipping",
  SEIN: "Seino Logix Co",
  SEJJ: "Sealand",
  SFTU: "Safetrans Line",
  SGNV: "Seatrade",
  SHKK: "DB Schenker",
  SHKU: "Sea Hawk Lines (SHAL)",
  SHPT: "Shipco Transport",
  SIKU: "Samudera Shipping Line",
  SJKU: "Sarjak Container Lines",
  SKLU: "Sinokor",
  SMLM: "SM Line (SML)",
  SMLU: "Seaboard Marine",
  SNTU: "STC",
  SPNU: "Salam Pacific Indonesia Lines (SPIL)",
  SQXN: "DP World Logistics",
  SSLL: "SACO Shipping Line",
  SSPH: "SETH Shipping",
  STIN: "Hugo Stinnes",
  SUDU: "Hamburg Sud",
  SYXO: "RTW Logistics",
  SZFG: "Shanghai League Shipping",
  TFFU: "Transit Fruits Eagle",
  TIDU: "Ti2 Container Lines",
  TJFH: "Transfar Shipping",
  TKRU: "TransContainer",
  TLXU: "Trans Asian Shipping Services",
  TMCU: "Transmar",
  TRKU: "Turkon",
  TRLS: "Transliner",
  TSHG: "Tailwind Shipping Lines",
  TSLU: "TCI Seaways",
  TVPI: "TVS Supply Chain Solutions",
  TVSU: "Transvision Shipping Line",
  TXZJ: "T.S. Lines",
  UAFL: "United Africa Feeder Line",
  UFEE: "Unifeeder",
  UWLD: "UWL",
  VCLU: "Volta Container Line",
  VGLT: "Vanguard Logistics",
  VIAS: "Viasea Shipping",
  WDSB: "World Direct Shipping (WDS)",
  WECU: "W.E.C. (West European Container) Lines",
  WHLC: "Wan Hai",
  WLWH: "Wallenius Wilhelmsen",
  WTLU: "White Line Shipping",
  WWSU: "Westwood Shipping Lines",
  YASV: "Yusen Logistics",
  YMLU: "Yang Ming",
  YSGS: "Globelink",
  ZIMU: "ZIM",
};

export const CARRIER_TBN_CODE = "TBN";
export const CARRIER_TBN_NAME = "Carrier TBN";

export type CarrierOption = { value: string; label: string };

/** Catalog options sorted by label (display name). */
export const CARRIER_OPTIONS: CarrierOption[] = Object.entries(CARRIERS_BY_CODE)
  .map(([value, label]) => ({ value, label }))
  .sort((a, b) => a.label.localeCompare(b.label));

/** TBN first, then catalog options. */
export const CARRIER_SELECT_OPTIONS: CarrierOption[] = [
  { value: CARRIER_TBN_CODE, label: CARRIER_TBN_NAME },
  ...CARRIER_OPTIONS,
];

/** Common short names / SCACs → catalog SCAC. */
const CARRIER_ALIASES: Record<string, string> = {
  msc: "MSCU",
  maersk: "MAEU",
  "maersk line": "MAEU",
  cosco: "COSU",
  cma: "CMDU",
  "cma cgm": "CMDU",
  cmacgm: "CMDU",
  one: "ONEY",
  hapag: "HLCU",
  "hapag lloyd": "HLCU",
  "hapag-lloyd": "HLCU",
  evergreen: "EGLV",
  "yang ming": "YMLU",
  yangming: "YMLU",
  zim: "ZIMU",
  hmm: "HDMU",
  "hamburg sud": "SUDU",
  "hamburg süd": "SUDU",
  pil: "PCIU",
  "wan hai": "WHLC",
  wanhai: "WHLC",
  sml: "SMLM",
  "sm line": "SMLM",
  ooo: "OOLU",
  oocl: "OOLU",
  tbn: CARRIER_TBN_CODE,
  "carrier tbn": CARRIER_TBN_CODE,
  "to be nominated": CARRIER_TBN_CODE,
  "to-be-nominated": CARRIER_TBN_CODE,
  "unknown carrier": CARRIER_TBN_CODE,
  unknown: CARRIER_TBN_CODE,
};

const normalize = (value: string): string =>
  value
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const levenshtein = (a: string, b: string): number => {
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;

  const prev = new Array<number>(b.length + 1);
  const curr = new Array<number>(b.length + 1);
  for (let j = 0; j <= b.length; j++) prev[j] = j;

  for (let i = 1; i <= a.length; i++) {
    curr[0] = i;
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
    }
    for (let j = 0; j <= b.length; j++) prev[j] = curr[j];
  }

  return prev[b.length];
};

const pack = (code: string): { code: string; name: string } => {
  if (code === CARRIER_TBN_CODE) return { code: CARRIER_TBN_CODE, name: CARRIER_TBN_NAME };
  return { code, name: CARRIERS_BY_CODE[code] ?? CARRIER_TBN_NAME };
};

/**
 * Resolve a raw carrier string (SCAC, full name, typo, or alias) to catalog entry.
 * No confident match → Carrier TBN.
 */
export const resolveCarrier = (raw: string): { code: string; name: string } => {
  const trimmed = raw.trim();
  if (!trimmed) return pack(CARRIER_TBN_CODE);

  const upper = trimmed.toUpperCase();
  if (upper === CARRIER_TBN_CODE || upper === "CARRIER TBN") return pack(CARRIER_TBN_CODE);
  if (CARRIERS_BY_CODE[upper]) return pack(upper);

  const norm = normalize(trimmed);
  if (!norm) return pack(CARRIER_TBN_CODE);

  const aliasCode = CARRIER_ALIASES[norm];
  if (aliasCode) return pack(aliasCode);

  // Exact name (case-insensitive, punctuation-insensitive)
  for (const [code, name] of Object.entries(CARRIERS_BY_CODE)) {
    if (normalize(name) === norm) return pack(code);
  }

  // includes / startsWith on full name or name tokens
  const tokenHits: string[] = [];
  for (const [code, name] of Object.entries(CARRIERS_BY_CODE)) {
    const nName = normalize(name);
    if (nName.startsWith(norm) || nName.includes(` ${norm}`) || norm.startsWith(nName) || nName.includes(norm)) {
      // Prefer longer / more specific: require query length >= 3 for includes
      if (norm.length >= 3) tokenHits.push(code);
    } else {
      const tokens = nName.split(" ").filter(Boolean);
      if (
        tokens.some(
          (t) => t === norm || (norm.length >= 3 && t.length >= 3 && (t.startsWith(norm) || norm.startsWith(t)))
        )
      ) {
        tokenHits.push(code);
      }
    }
  }
  if (tokenHits.length === 1) return pack(tokenHits[0]);
  // Multiple includes hits: prefer exact token equality on first significant token
  if (tokenHits.length > 1) {
    const exactToken = tokenHits.filter((code) => {
      const tokens = normalize(CARRIERS_BY_CODE[code]).split(" ");
      return tokens.includes(norm);
    });
    if (exactToken.length === 1) return pack(exactToken[0]);
  }

  // Levenshtein against names and codes (typos like mearsk → Maersk)
  let bestCode: string | null = null;
  let bestDist = Infinity;
  let bestTie = Infinity;
  const maxDist = norm.length <= 5 ? 1 : norm.length <= 10 ? 2 : 3;

  for (const [code, name] of Object.entries(CARRIERS_BY_CODE)) {
    const nName = normalize(name);
    const dName = levenshtein(norm, nName);
    const dCode = levenshtein(norm, code.toLowerCase());
    // Also compare against primary token (first word) for short typos
    const first = nName.split(" ")[0] ?? "";
    const dFirst = first ? levenshtein(norm, first) : Infinity;
    const d = Math.min(dName, dCode, dFirst);
    // Tie-break: prefer exact full-name distance, then shorter brand name (Maersk over Maersk Line Limited)
    const tie = (dName === d ? 0 : 10) + nName.length;
    if (d <= maxDist && (d < bestDist || (d === bestDist && tie < bestTie))) {
      bestDist = d;
      bestTie = tie;
      bestCode = code;
    }
  }

  if (bestCode !== null && bestDist <= maxDist) return pack(bestCode);

  return pack(CARRIER_TBN_CODE);
};
